var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ChevronDown component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconChevronDown extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.32416 7.03705C2.61706 6.74416 3.09193 6.74416 3.38482 7.03705L11.9995 15.6517L20.6142 7.03705C20.9071 6.74416 21.3819 6.74416 21.6748 7.03705C21.9677 7.32995 21.9677 7.80482 21.6748 8.09771L13.0291 16.7434C12.8977 16.8807 12.7402 16.9903 12.5657 17.0658C12.387 17.1432 12.1943 17.1831 11.9995 17.1831C11.8047 17.1831 11.612 17.1432 11.4332 17.0658C11.2588 16.9903 11.1013 16.8807 10.9699 16.7434L2.32416 8.09771C2.03127 7.80482 2.03127 7.32995 2.32416 7.03705Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconChevronDown.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconChevronDown.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconChevronDown.prototype, "size", void 0);
if (customElements.get('cat-icon-chevron-down') === undefined) {
    customElements.define('cat-icon-chevron-down', BlocksIconChevronDown);
}
